import * as React from 'react';
import { ArticleHeading1 } from '@cian/ui-kit/typography';
import * as styles from './styles.css';

export interface IFullscreenGalleryCategoryProps {
  title: React.ReactNode;
  children: React.ReactNode;
  name?: string;
}

export function Category({ title, children, name }: IFullscreenGalleryCategoryProps) {
  return (
    <div className={styles['container']}>
      <div id={name} className={styles['heading']}>
        <ArticleHeading1 as={'h2'}>{title}</ArticleHeading1>
      </div>
      <div className={styles['content']}>{children}</div>
    </div>
  );
}
